import { CommonModule } from '@angular/common';
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { ApiClientService } from "@shared/_services/api-client.service";
import { PreloaderComponent } from '@app/modules/utils/preloader/preloader.component';
import { ManageCategoriesComponent } from './manage-categories/manage-categories.component';
import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';
import Swal from "sweetalert2";

@Component({
  selector: 'app-categories-conf',
  standalone: true,
  imports: [CommonModule, PreloaderComponent, ManageCategoriesComponent],
  templateUrl: './categories-conf.component.html',
  styleUrl: './categories-conf.component.css'
})
export class CategoriesConfComponent {

  public loading: boolean = false;
  public hasError: boolean = false;
  public errorMsg: string = '';
  public categories: any = [];
  public selectedAction: string = 'view-all';
  public manageCategoryData: any = {};

  constructor(private _apiClientService: ApiClientService, private _toastrService: ToastrService) { }

  ngOnInit() {
    this.getAllCategories();
    this.selectCategoryAction('view-all');
  }

  public async getAllCategories() {
    this.loading = true;
    (await this._apiClientService.readAllApiService(`select-option?q=category`)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("Categories Details ", event.body);
            let { status, error, message, data } = event.body;
            //if (status == 200) {

            this.categories = event.body.sort(this.compare);
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  private compare(a: any, b: any): any {
    const bandA = a.order;
    const bandB = b.order;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  public triggerDelete(category: any) {
    console.log(category);
    const self = this;
    Swal.fire({
      title: 'Delete Category',
      text: 'Do you want to delete this category?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#dc3545', // Green color for Yes button
      cancelButtonColor: '#9b9b9b',  // Red color for No button
    }).then((result: any) => {
      /* Read more about isConfirmed, isDenied below */
      console.log(result.isConfirmed);
      if (result.isConfirmed) {
        console.log(result);
        this.deleteCategory(category);
      }
    });
  }

  public async deleteCategory(category: any) {
    this.loading = true;
    (await this._apiClientService.addApiService(`admin/select-option/category/remove`, {
      "categoryId": category.id
  } )).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            console.log("Region Deleted ", event.body);
            this._toastrService.success('Deleted Region Successfully', 'Success');
            let { status, error, message, data } = event.body;
            //if (status == 200) {
            this.getAllCategories();
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  public selectCategoryAction(action: string, data: any = ''): void {

    this.manageCategoryData = [];
    switch (action) {
      case 'view-all':
      case 'cancel':
      case 'completed':
        this.selectedAction = 'view-all';
        this.getAllCategories();
        break;
      case 'add':
        this.selectedAction = 'manage-category';
        this.manageCategoryData = { action: 'add' };
        break;
      case 'edit':
        this.selectedAction = 'manage-category';
        this.manageCategoryData = { action: 'edit', data: data };
        break;
    }
  }

  public receiveCategoryResponse($event: string) {
    console.log("Category Response ", $event);
    this.selectCategoryAction($event);
  }

}
